// extracted by mini-css-extract-plugin
module.exports = {"root":"Form_root__1g6uu","footer":"Form_footer__3puXT"};